import { GIT_SHA, IS_DEV } from './viteEnv';
import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './00_init';
import './01_i18n';
import App from './App';
import ENV from './env.json';
import './index.css';
import { initSentry } from './sentry';
import * as serviceWorker from './serviceWorker';
import { start } from './stackdriverErrorReporter';

initSentry();

start({
  key: ENV.errorReporting.apiKey,
  projectId: ENV.errorReporting.projectId,
  service: ENV.errorReporting.service,
  version: GIT_SHA,
  disabled: IS_DEV
});

ReactDOM.render(
  <Suspense fallback={null}>
    <App />
  </Suspense>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
